<template>
	<mobile v-if="mobile"></mobile>
	<pc v-else></pc>
</template>

<script>
	import pc from './message_list_pc.vue'
	import mobile from './message_list_m.vue'
	import {mapState} from 'vuex'
	
	export default {
		name: 'message_list',
		
		components: {
			pc,
			mobile
		},
		
		computed: {
			...mapState(['mobile'])
		}
	};
</script>

<style lang="stylus" scoped>
</style>